import { useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import { Badge } from 'react-bootstrap'
import { type ShortOAuth2App } from '../../../store/auth/auth'
import { OAuth2AppsButtonManager } from '../../../views/OAuth2App/OAuth2AppManagement/Components/OAuth2AppsButtonManager'
import { CommonCard } from '../../Card/CommonCard'
import './OAuth2AppCard.scss'
import { OAuth2AppsModalManager, OAuth2AppsModalType } from '../../../views/OAuth2App/OAuth2AppManagement/Modals/OAuth2AppsModalManager'

export interface OAuth2AppCardProps {
  oAuth2App: ShortOAuth2App
}

export const OAuth2AppCard: React.FC<OAuth2AppCardProps> = ({ oAuth2App }) => {
  const { name, clientId, imageUrl, shortDescription, type } = oAuth2App
  const navigate = useNavigate()

  const initials = name.slice(0, 2).toUpperCase() || '?'
  const showPrivateBadge = type === 'dev' || type === 'internal'

  const [activeModal, setActiveModal] = useState<OAuth2AppsModalType>(null)

  const handleCardClick = () => {
    navigate(`/account/integration-settings/oauth2apps/${clientId}/about`)
  }

  const descriptionView = (
    <div className='h-auto'>
      <span className='app-card-name-label'>{name}</span>
      <div className='zocks-text-gray-600'>{shortDescription}</div>
    </div>
  )

  return (
    <>
      <OAuth2AppsModalManager oAuth2App={oAuth2App} activeModal={activeModal} onClose={() => setActiveModal(null)} />
      <CommonCard
        onCardClick={handleCardClick}
        header={
          <div className='d-flex align-items-start justify-content-between'>
            <div className='app-card-icon'>
              {imageUrl ? (
                <img src={imageUrl} alt={`${name} logo`} className='app-card-icon' />
              ) : (
                <span className='app-card-icon app-icon-initials'>{initials}</span>
              )}
            </div>
            {showPrivateBadge ? (
              <Badge bg='' className='app-card-private-badge'>
                <i className='bi bi-lock me-1' />
                Private
              </Badge>
            ) : null}
          </div>
        }
        description={<div>{descriptionView}</div>}
        state={<></>}
        footer={
          <OAuth2AppsButtonManager
            oAuth2App={oAuth2App}
            hideDisableButton={true}
            hideRevokeAccessButton={true}
            onRequestModal={(modal) => setActiveModal(modal)}
          />
        }
      />
    </>
  )
}
